import { useState, useCallback, memo } from 'react';
import { ProjectCard } from './ProjectCard.js';


/**
 * A div wrapping a {@link ProjectCard}, plus an additional empty div that we can mount Portals into as needed.
 *
 * We added this as a hack around limitations caused by ProjectCard being an anchor tag. (Specifically: ProjectCard
 * couldn't have any *children* that were anchor tags, because nested anchor tags are invalid HTML.) We might not need
 * this anymore.
 */
export let ProjectCardWithSibling = function (props) {
    // Has to live in state so that rerender happens on update
    const [siblingNode, setSiblingNode] = useState(null);

    // This is based on https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node ,
    // but I think we could have just passed setSiblingNode instead of siblingNodeRef here.
    const siblingNodeRef = useCallback(node => {
        if (node != null) {
            setSiblingNode(node);
        }
    }, []);

    return (
        <div>
            <ProjectCard {...props} portalTarget={siblingNode} />
            <div ref={siblingNodeRef} />
        </div>
    );
};
ProjectCardWithSibling = memo(ProjectCardWithSibling);

const propTypes = Object.assign({}, ProjectCard.propTypes);
delete propTypes.portalTarget;
ProjectCardWithSibling.propTypes = propTypes;
